import React from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import ChangePassword from '../components/User/ChangePassword';
import Modal from 'react-modal';

export default function Reset() {
  sendGAPageview({
    hitType: 'pageview',
    page: '/Reset',
    title: 'Reset password',
  });

  const customStyles = {
    content: {
      position: 'relative',
      top: '50%',
      transform: 'translateY(-57%)',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '600px',
      background: 'transparent',
      boxSizing: 'border-box',
      border: null,
      padding: null,
    },
  };

  return (
    <>
      <Helmet>
        <title>DISGENET: Reset Password</title>
        <meta name="description" content="Reset your DISGENET password." />
      </Helmet>
      <ChangePassword onClose={() => {}} />
    </>
  );
}
